import { useDispatch, useSelector } from "react-redux";
import { saveSession } from "../store/slice/auth.slice";
import { useNavigate } from "react-router-dom";
import { appConfig } from "../config/app.config";
import Cookies from 'js-cookie';
import apiClient from "../api/axios";
const useAuth = () => {
    const Navigate = useNavigate();
    const {user, isAuthenticated: isLoaggedIn} = useSelector((state) => state.auth)
    const dispatch = useDispatch();

    const onRefreshToken = async (user) => {
        // Prefer backend-provided flag (login response), fallback to derive.
        let superManager =
            user?.super_manager === undefined || user?.super_manager === null
                ? false
                : Boolean(user?.super_manager);

        // If manager: derive "super_manager" from managers table (is_owner)
        if (
            (user?.super_manager === undefined || user?.super_manager === null) &&
            user?.role === "manager" &&
            user?.manager_id != null
        ) {
            try {
                const resp = await apiClient.get("/profile/managers");
                const managers = resp?.data?.data ?? resp?.data ?? [];
                const manager = Array.isArray(managers)
                    ? managers.find((m) => String(m?.id) === String(user?.manager_id))
                    : null;
                superManager = String(manager?.is_owner) === "1" || manager?.is_owner === true;
            } catch (e) {
                superManager = false;
            }
        }

        // Keep `is_owner` for compatibility with existing UI code.
        dispatch(saveSession({ ...user, super_manager: superManager, is_owner: superManager }));

        if (user?.role === "manager") {
            Navigate('/manager-dashboard'); // Navigate to manager-specific page
        } else if (user?.role === "employee") {
            Navigate('/landing-page'); // Navigate to user-specific page
        } else {
            // Navigate('/Superadmin-dashboard')
            Navigate('/view-org')
        }
    }
    console.log(isLoaggedIn, "isLoaggedIn");

    const logout = async () => {
        try {
            localStorage.clear();
            Cookies.remove(appConfig.tokenName)
            // const token = localStorage.getItem('authToken');
            // if (token) {
            //     // Optionally, send a request to invalidate the token on the backend
            //     await fetch('/api/logout', {
            //         method: 'POST',
            //         headers: {
            //             'Authorization': `Bearer ${token}`,
            //         },
            //     });
            // }
            dispatch(logout()); // Remove the user and authentication state
            Navigate('/'); // Redirect to the login page
        } catch (error) {
            console.error("Error logging out:", error);
        }
    };
    // const logout = () => {
    //     dispatch(logoutAction()); // Assuming you have a logout action
    //     Navigate('/login');
    //   };
    

    return {

        isLoaggedIn: isLoaggedIn,
        users: user,
        onRefreshToken,
        logout
    }
}

export default useAuth;